<template>
  <div id="main-box" style="overflow:auto;">
    <div id="content-box">
      <div style="padding: 0 0 10px 0;padding-left: 2px;font-size: 18px;">拉取商品：

      </div>
      <el-card>
        <div style="padding:20px;">
          <el-radio-group v-model="radio" @change="fetchBy">
            <el-radio :label="1">直接拉取</el-radio>
            <el-radio :label="2">数据匹配拉取</el-radio>
          </el-radio-group>
        </div>
        <div style="display:inline-block" v-if="directType">
          <div
              class="updata_view"
              v-loading="uploading"
              element-loading-text="正在上传..."
          >
            <el-upload
                ref="upLoadFile"
                class="upload-demo"
                drag
                action="#"
                :auto-upload="false"
                :on-change="updataLogistics"
                :on-remove="removeLogistics"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或
                <em>点击上传</em>
              </div>
              <div class="el-upload__tip" style="margin:20px;" slot="tip">
                只能上传xlsx文件
                <el-button type="text" @click="upDataInfo()"
                >下载导入模板
                </el-button>

              </div>
            </el-upload>
          </div>
          <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-preventClick @click="handleExpSubmit()"
        >确 定</el-button
        >
      </span>
        </div>
        <div>
          <div class="contrast" v-if="matchType">
            <div class="left-box">
              <el-form>
                <el-form-item>
                  <span class="txt">平台数据</span>
                </el-form-item>
                <el-form-item label="品牌：">
                  <!--                  <el-autocomplete-->
                  <!--                      v-model="brandName"-->
                  <!--                      @handleInput="handleBrandInput"-->
                  <!--                      @handleSelect="handleBrandSelect"-->
                  <!--                  ></el-autocomplete>-->

                  <el-autocomplete
                      v-model="submitData.brandName"
                      :fetch-suggestions="querySearchAsync"
                      placeholder="请选择"
                      @select="handleSelect"
                      clearable
                      @clear="clearBtn"
                  ></el-autocomplete>
                </el-form-item>
                <el-form-item label="类型：">
                  <!--                  <el-cascader-->
                  <!--                      v-model="formData.typeId"-->
                  <!--                      :props="{ value: 'Id', label: 'TypeName', children: 'Childrens' }"-->
                  <!--                      :show-all-levels="true"-->
                  <!--                      :options="productNavTypeTreeList"-->
                  <!--                      placeholder="请选择类型"-->
                  <!--                      @change="handleSelType"-->
                  <!--                  ></el-cascader>-->
                  <!--                  note  emitPath false  返回选中的 当前节点id true 返回 包含父级的数组-->
                  <el-cascader
                      ref="cascader1"
                      v-model="CategoryIds"
                      :props="{ emitPath: false, checkStrictly: true }"
                      :show-all-levels="false"
                      :options="productNavTypeTreeList"
                      placeholder="请选择类型"
                      clearable
                      @change="handleSelType"
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="是否跳过首图：">
                  <el-checkbox v-model="submitData.IsSkipFirstPic"></el-checkbox>
                </el-form-item>
              </el-form>
            </div>
            <div class="left-box">
              <el-form>
                <el-form-item>
                  <span class="txt">外部商品库</span>
                </el-form-item>
                <el-form-item label="品牌：">
                  <!--                  <el-autocomplete-->
                  <!--                      v-model="brandName"-->
                  <!--                      @handleInput="handleBrandInput"-->
                  <!--                      @handleSelect="handleBrandSelect"-->
                  <!--                  ></el-autocomplete>-->

                  <el-autocomplete
                      v-model="brandName1"
                      :fetch-suggestions="querySearchAsync1"
                      placeholder="请选择"
                      @select="handleSelect1"
                      clearable
                      @clear="clearBtn1"
                  ></el-autocomplete>
                </el-form-item>
                <el-form-item label="类型：">

                  <!--                  :props="{ value: 'Id', label: 'TypeName', children: 'Childrens' }"-->
                  <el-cascader
                      v-model="JdTypeId"
                      :props="{ emitPath: false, checkStrictly: true }"
                      :show-all-levels="false"
                      :options="productNavTypeTreeList1"
                      placeholder="请选择类型"
                      clearable
                      @change="handleSelType1"
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="平台类型：">
                  <el-select v-model="submitData.PlatformCodeType" @change="selectType">
                    <el-option :value="1" label="京东开普勒"></el-option>
                    <el-option :value="2" label="京东店铺"></el-option>
                    <!--                    <el-option :value="2" label="京东开普特专供政策"></el-option>-->
                    <!--                    <el-option :value="3" label="京东开普勒通用政策"></el-option>-->
                    <!--                    <el-option :value="4" label="京东开普勒节点政策"></el-option>-->
                    <!--                    <el-option :value="5" label="京东开普勒询价政策"></el-option>-->
                  </el-select>
                </el-form-item>
                <!--                <el-form-item label-width="160px">-->
                <!--                  <el-button type="primary" @click="determineBtn">确定</el-button>-->
                <!--                </el-form-item>-->
              </el-form>
            </div>
          </div>
          <div v-if="matchType"
               style="padding-top:20px;padding-left:-80px;display:flex;justify-content:center;align-items:center">
            <el-form>
              <el-form-item>
                <el-button type="primary" @click="determineBtn">确定</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!--          <div class="arrow el-icon-d-arrow-right" icon="el-icon-d-arrow-right" v-if="isShowJD">-->
        <!--          </div>-->
        <!--          <div class="left-box" v-if="isShowJD">-->
        <!--            <el-form>-->
        <!--              <el-form-item>-->
        <!--                <span class="txt">京东库</span>-->
        <!--              </el-form-item>-->
        <!--              <el-form-item label="品牌：">-->
        <!--                <autocomplete-->
        <!--                  v-model="JDbrandData"-->
        <!--                  @handleInput="handleJDBrandInput"-->
        <!--                  @handleSelect="handleJDBrandSelect"-->
        <!--                ></autocomplete>-->
        <!--              </el-form-item>-->
        <!--              <el-form-item label="类型：">-->
        <!--                <el-cascader-->
        <!--                  v-model="formData.jdTypeId"-->
        <!--                  :props="{ value: 'Id', label: 'TypeName', children: 'Childrens' }"-->
        <!--                  :show-all-levels="true"-->
        <!--                  :options="JdTypeList"-->
        <!--                  placeholder="请选择类型"-->
        <!--                  @change="handleSelJDType"-->
        <!--                ></el-cascader>-->
        <!--              </el-form-item>-->
        <!--              <el-form-item label="是否跳过首图：" v-if="form.JdTypeIndex > 1">-->
        <!--                <el-checkbox v-model="formData.skipOnePic">是否跳过图片列表首图</el-checkbox>-->
        <!--              </el-form-item>-->
        <!--              <el-form-item label="是否添加营客通巨惠：" v-if="form.JdTypeIndex == 6">-->
        <!--                <el-checkbox v-model="formData.isJoinBigPurchase">是否添加营客通巨惠</el-checkbox>-->
        <!--              </el-form-item>-->
        <!--              <el-form-item label="巨惠编码：" v-if="formData.isJoinBigPurchase">-->
        <!--                <el-autocomplete-->
        <!--                  v-model="formData.bigPurchaseName"-->
        <!--                  :fetch-suggestions="querySearchAsync"-->
        <!--                  placeholder="请输入内容"-->
        <!--                  @select="handleSelect"-->
        <!--                ></el-autocomplete>-->
        <!--              </el-form-item>-->
        <!--              <el-form-item label-width="140px">-->
        <!--                <el-button type="primary" @click="submitBtn">获取商品</el-button>-->
        <!--              </el-form-item>-->
        <!--            </el-form>-->
        <!--          </div>-->
      </el-card>
      <div style="padding: 20px 0 10px 0;padding-left: 2px;font-size: 18px;">操作记录：</div>
      <el-card style="position:relative;">
        <div>
          <el-form :inline="true">
            <el-form-item label="操作时间:">
              <el-radio-group v-model="queryForm.TimeType">
                <el-radio :label="1">今天</el-radio>
                <el-radio :label="2">近7天</el-radio>
                <el-radio :label="3">近30天</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="操作人:">
              <el-input size="small" v-model="queryForm.creatorUser" placeholder="请输入内容"></el-input>
            </el-form-item>

            <el-form-item label="选择时间">
              <!--              <el-col :span="11">-->
              <!--                <el-form-item>-->
              <!--                  <el-date-picker type="date" size="small" placeholder="年/月/日" v-model="queryForm.StartTime"-->
              <!--                                  style="width: 100%;"></el-date-picker>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <!--              <el-col class="line" :span="1">~</el-col>-->
              <!--              <el-col :span="11">-->
              <!--                <el-form-item>-->
              <!--                  <el-date-picker type="date" size="small" placeholder="年/月/日" v-model="queryForm.EndTime"-->
              <!--                                  style="width: 100%;"></el-date-picker>-->
              <!--                </el-form-item>-->
              <!--              </el-col>-->
              <el-date-picker
                  v-model="valueTime"
                  type="datetimerange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="handlePicker"
              ></el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" size="small" @click="search">筛选</el-button>
              <el-button size="small" @click="empty">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="padding-bottom: 15px;">
          <toolbar
              :buttonList="buttonList_toolBar"
              @callFunction="callFunction"
          ></toolbar>
        </div>
        <el-table
            id="user-table"
            :data="userList"
            highlight-current-row
            v-loading="tableLoading"
            @selection-change="handleSelectionChange"
            style="width: 100%"
            border
        >
          <el-table-column
              type="index"
              label="方式"
              width="200"
              align="center">
            <template slot-scope="scope">
              {{ scope.row.syncType === 1 ? '导入' : '拉取' }}
            </template>
          </el-table-column>
          <el-table-column
              prop="creationTime"
              label="操作时间"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="creatorUser"
              label="操作人"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="skuId"
              label="操作内容"
              min-width="180"
              align="center"
          >
            <template slot-scope="scope">
              <div style="display: flex;justify-content: center;align-items: center">
                <span v-if="scope.row.syncType=== 1" style="display: inline-block;margin-right:10px;">导入{{
                    scope.row.allNum
                  }}条</span>
                <span v-else style="display: inline-block;margin-right:10px;">
                   获取{{ scope.row.brandName }}品牌,
                  {{ scope.row.typeNames }}品类, 总共 {{ scope.row.allNum }}条,</span>
                <!--                <span style="display: inline-block;margin-right:10px;"></span>-->
                <span style="display: inline-block;margin-right:10px;">成功{{ scope.row.successNum }}条,</span>
                <span style="display: inline-block;margin-right:10px;">失败{{ scope.row.failNum }}条,</span>
                <span style="display: inline-block;margin-right:10px;">自动跳过{{ scope.row.skipNum }}条</span>


              </div>

            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            style="float: right"
            :total="total"
            :current-page="queryForm.pageIndex"
            :pageSize="queryForm.pageSize"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
        ></el-pagination>
      </el-card>
    </div>


    <el-dialog
        title="添加商品"
        :visible.sync="addProductDialog"
        v-if="addProductDialog"
        v-model="addProductDialog"
        :close-on-click-modal="false"
        width="80%"
    >
      <el-form :inline="true" ref="addProductForm" :model="addProductForm">
        <el-form-item label="选择分销商">
          <el-select size="small" v-model="addProductForm.distributor">
            <el-option :value="null" label="全部"></el-option>
            <el-option :value="true" label="正常"></el-option>
            <el-option :value="false" label="禁用"></el-option>
          </el-select>
        </el-form-item>
        <div style="background-color: #F3F3F3;padding: 20px 20px 0 20px;border-radius: 6px;margin-bottom: 20px;">
          <el-form-item label="商品spuid:">
            <el-input
                v-model="addProductForm.SpuId"
                placeholder="请输入商品Id"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品名称:">
            <el-input
                v-model="addProductForm.ProName"
                placeholder="请输入商品名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品型号:">
            <el-input
                v-model="addProductForm.ProCode"
                placeholder="请输入型号"
            ></el-input>
          </el-form-item>
          <el-form-item label="商品类型">
            <el-cascader
                v-model="addProductForm.ProTypeId"
                :props="{ value: 'Id', label: 'TypeName', children: 'Childrens' }"
                :show-all-levels="false"
                :options="productNavTypeTreeList"
                placeholder="请选择类型"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="商品品牌">
            <el-select
                :disabled="brandId != null"
                v-model="addProductForm.ProBrandId"
                filterable
                allow-create
                default-first-option
                placeholder="请选择品牌"
            >
              <el-option
                  v-for="(item, index) in brandList"
                  :key="index"
                  :label="item.value"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left: 40px">
            <el-button type="primary" @click="searchFun(1)">查询</el-button>
            <el-button type="danger" @click="resetFun">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
      <el-table
          :data="addProductList"
          @selection-change="handleSelectionChange"
          border
      >
        <el-table-column
            type="selection"
            width="50"
            fixed
            align="center"
        ></el-table-column>
        <el-table-column
            prop="SpuId"
            label="SpuId"
            min-width="80"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="ProName"
            label="商品名称"
            align="center"
            min-width="350"
        ></el-table-column>
        <el-table-column
            prop="ProTypeName"
            label="商品类型"
            min-width="110"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="ProBrandName"
            label="商品品牌"
            min-width="110"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="ProCode"
            label="商品型号"
            min-width="110"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="CostPrice"
            label="成本价"
            min-width="110"
            align="center">
        </el-table-column>
      </el-table>
      <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          style="float: right"
          :total="total"
          :current-page="addProductForm.pageIndex"
          :pageSize="addProductForm.pageSize"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
      ></el-pagination>
      <div slot="footer" class="dialog-footer" style="width:100%;">
        <el-button @click.native="addProductDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitAddPro" :loading="submitLoading">下一步</el-button>
      </div>
    </el-dialog>


    <el-dialog
        title="设置价格"
        :visible.sync="setPriceDialog"
        v-if="setPriceDialog"
        v-model="setPriceDialog"
        :close-on-click-modal="false"
        width="75%"
    >
      <el-table
          border
          :data="setPriceList"
          :header-cell-style="{background:'#F3F3F3'}"
          id="act-set-table"
          :span-method="objectSpanMethod"
      >
        <el-table-column
            prop="proName"
            min-width="120"
            align="center"
            label="商品名称">
        </el-table-column>
        <el-table-column
            prop="distributor"
            min-width="120"
            align="center"
            label="分销商">
        </el-table-column>
        <el-table-column
            prop="specName"
            min-width="120"
            align="center"
            label="规格名称">
        </el-table-column>
        <el-table-column
            prop="costPrice"
            min-width="120"
            align="center"
            label="成本价">
        </el-table-column>
        <el-table-column label="供货价" min-width="120" align="center" style="border: red solid 1px;">
          <template slot-scope="scope">
            <el-input v-model="scope.row.supplyPrice" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column
            min-width="100"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.status">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addProductDialog = false, setPriceDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitSetPrice">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
        title="商品同步"
        :visible.sync="proSyncDialog"
        v-if="proSyncDialog"
        v-model="proSyncDialog"
        :close-on-click-modal="false"
        width="75%"
    >
      <el-table
          border
          :data="syncList"
          :header-cell-style="{background:'#F3F3F3'}"
          id="act-set-table"
      >
        <el-table-column
            prop="distributor"
            min-width="120"
            align="center"
            label="分销商名称">
        </el-table-column>
        <el-table-column
            prop="proNum"
            min-width="120"
            align="center"
            label="需同步商品数">
        </el-table-column>
        <el-table-column
            min-width="100"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button @click="oneKeySync(scope.row)" type="primary" size="small">一键同步</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="proSyncDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitOneKeySync">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
        title="批量设置价格"
        :visible.sync="batchSetPriceDialog"
        v-if="batchSetPriceDialog"
        v-model="batchSetPriceDialog"
        :close-on-click-modal="false"
        width="75%"
    >
      <el-table
          border
          :data="batchSetPriceList"
          :header-cell-style="{background:'#F3F3F3'}"
          id="act-set-table"
      >
        <el-table-column
            prop="proName"
            min-width="120"
            align="center"
            label="商品名称">
        </el-table-column>
        <el-table-column
            prop="distributor"
            min-width="120"
            align="center"
            label="分销商">
        </el-table-column>
        <el-table-column
            prop="specName"
            min-width="120"
            align="center"
            label="规格名称">
        </el-table-column>
        <el-table-column
            prop="costPrice"
            min-width="120"
            align="center"
            label="成本价">
        </el-table-column>
        <el-table-column label="供货价" min-width="120" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.supplyPrice" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column
            min-width="100"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-radio-group v-model="scope.row.status">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchSetPriceDialog = false">取消</el-button>
        <el-button type="primary" @click.native="submitBatchSetPrice">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="拉取商品"
        :visible.sync="infoDialog"
        width="30%"
        center>
      <div>
        <!--        <span style="display: inline-block;margin-right:10px;">导入{{ scope.row.allNum }}条</span>-->
        <span style="display: inline-block;margin-right:10px;">成功{{ infoData.successNum }}条</span>
        <span style="display: inline-block;margin-right:10px;">失败{{ infoData.failNum }}条</span>
        <span style="display: inline-block;margin-right:10px;">已存在{{ infoData.skipNum }}条自动跳过</span>
      </div>
      <div v-if="infoData.errSkuIds">
        {{ infoData.errSkuIds }}
      </div>

      <!--      <span style="display: inline-block;margin-right:10px;">获取{{ scope.row.brandName }}品牌,品类商品</span>-->
      <!--      <span style="display: inline-block;margin-right:10px;">成功{{ scope.row.successNum }}条</span>-->
      <!--      <span style="display: inline-block;margin-right:10px;">失败{{ scope.row.failNum }}条</span>-->
      <!--      <span style="display: inline-block;margin-right:10px;">自动跳过{{ scope.row.skipNum }}条</span>-->

      <span slot="footer" class="dialog-footer">
    <el-button @click="infoDialog = false">取 消</el-button>
    <el-button type="primary" @click="infoDialog = false">确 定</el-button>
  </span>
    </el-dialog>

    <el-dialog
        title="导入拉取商品"
        :visible.sync="importDialog"
        width="30%"
        center>
      <div>
        <!--        <span style="display: inline-block;margin-right:10px;">导入{{ scope.row.allNum }}条</span>-->
        <span style="display: inline-block;margin-right:10px;">成功{{ infoData.successNum }}条</span>
        <span style="display: inline-block;margin-right:10px;">失败{{ infoData.failNum }}条</span>
        <span style="display: inline-block;margin-right:10px;">已存在{{ infoData.skipNum }}条自动跳过</span>
      </div>
      <div v-if="infoData.errSkuIds">
        {{ infoData.errSkuIds }}
      </div>

      <!--      <span style="display: inline-block;margin-right:10px;">获取{{ scope.row.brandName }}品牌,品类商品</span>-->
      <!--      <span style="display: inline-block;margin-right:10px;">成功{{ scope.row.successNum }}条</span>-->
      <!--      <span style="display: inline-block;margin-right:10px;">失败{{ scope.row.failNum }}条</span>-->
      <!--      <span style="display: inline-block;margin-right:10px;">自动跳过{{ scope.row.skipNum }}条</span>-->

      <span slot="footer" class="dialog-footer">
    <el-button @click="importDialog = false">取 消</el-button>
    <el-button type="primary" @click="importDialog = false">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetAllUser,
  CreateUser,
  GetUserDetail,
  UpdateUser,
  DeleteUser,
  GetRoles, OrderLogisticUpload, brandGetAll, CategoryGetTree,
  JdBrandGetAll,
  JdTypeGetAll, ProductPlatformSyncRecordGetAll,
  GetJDCtpProduct,
  ProductUploadJDCtp,
  JDPopProductQuery

} from "../../api/api";
import toolbar from "../../components/Toolbar";
import {getButtonList} from "../../promissionRouter";
import autocomplete from "../../components/autocomplete";

export default {
  components: {toolbar},
  data() {
    return {
      fileLog: null,
      uploading: false,
      radio: 1,
      isShowJD: false,
      directType: true,
      matchType: false,
      form: {
        JdTypeIndex: 0,
      },
      JdTypeList: [],
      JDbrandData: {
        name: "",
        restaurants: [],
      },

      // brandmodelData: {
      //   name: "",
      //   restaurants: [],
      // },
      brandmodelData: '',
      brandName: '',
      brandName1: '',
      CategoryIds: null,
      productNavTypeTreeList: [],
      productNavTypeTreeList1: [],
      formData: {
        typeId: null,
        jdTypeId: null,
        brandId: null,
        jdBrandId: null,
        jdBrandName: '',
        skipOnePic: false,
        bigPurchaseId: null,
        bigPurchaseName: null,
        isJoinBigPurchase: false
      },
      buttonList_toolBar: [],
      buttonList_table: [],

      tableLoading: false,
      currentRow: [],
      total: 0,
      queryForm: {
        TimeType: null,
        creatorUser: null,
        StartTime: null,
        EndTime: null,
        PageIndex: 1,
        PageSize: 10
      },
      userList: [],
      submitLoading: false,

      addProductDialog: false,
      addProductForm: {
        SpuId: null,
        ProName: null,
        ProCode: null,
        ProTypeId: null,
        ProBrandId: null,
        pageIndex: 1,
        pageSize: 10
      },
      addProductList: [
        {
          SpuId: 11,
          ProName: 'pro1',
          ProTypeName: '自有',
          ProBrandName: '美的',
          ProCode: 222,
          CostPrice: 11111
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        },
        {
          SpuId: 22,
          ProName: 'pro2',
          ProTypeName: '自有',
          ProBrandName: '海尔',
          ProCode: 22222,
          CostPrice: 3333
        }
      ],

      setPriceDialog: false,
      setPriceList: [
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
      ],

      proSyncDialog: false,
      syncList: [
        {
          distributor: 'cc',
          proNum: 'cc'
        },
        {
          distributor: 'cc',
          proNum: 'cc'
        },
      ],

      batchSetPriceDialog: false,
      batchSetPriceList: [
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
        {
          proName: 'cc',
          distributor: 'cc',
          specName: 'dd',
          costPrice: 'dd',
          supplyPrice: 'dd',
          status: null
        },
      ],
      JdBrandList: [],
      Categorys: [],
      submitData: {
        brandName: '',
        IsSkipFirstPic: false,
        brandId: null,
        PlatformCodeType: null,
        sourceType: 1,
        SourceId: null,
        PlatformSyncType: 1,
        JdTypeName: '',
        JdTypeId: null, // 京东分类
      },
      JdTypeId: null,
      infoDialog: false,
      infoData: {},
      valueTime: [],
      importDialog: false,
    };
  },
  mounted() {
    this.renderButton();
  },
  created() {
    if (this.$route.query.id) {
      this.submitData.SourceId = this.$route.query.id;
      // console.log(' this.submitData.SourceId', this.submitData.SourceId)
    } else {
      return this.$message.error('缺少供应商Id,参数缺失')
    }
    this.getProductNavTypeTree();
    // JdBrandGetAll,
    //     JdTypeGetAll
    // jd品牌
    this.getJdBrandGetAll();
    // jd 类型
    this.getJdTypeGetAll();
    // 操作记录
    // ProductPlatformSyncRecordGetAll
    this.getProductPlatformSyncRecordGetAll();
  },
  watch: {
    "CategoryIds": {
      handler(n, o) {
        let arr = this.$refs['cascader1'].getCheckedNodes()[0].pathNodes;
        // console.log('arr---------', arr)
        // return;
        this.Categorys = [];
        let newArr = [];
        arr.forEach(x => {
          // console.log('value, label', x.value, x.label)
          newArr.push({
            categoryId: x.value,
            categoryName: x.label
          });
        })
        this.Categorys = newArr;
        this.submitData.Categorys = newArr;
        // console.log('newArr', newArr);

        // note   ==
        let selected = this.Categorys.find(x => {
          return x.categoryId === n;
        })
        // console.log('arr---------', arr)
        this.submitData.CategoryId = selected.categoryId;
        this.submitData.CategoryName = selected.categoryName;
        // console.log('this.submitData---------', this.submitData)
        // console.log('selected---------', selected)
        // console.log('this.Categorys---------', this.Categorys)
        // console.log('n---------', n)
      },
      deep: true
    },
  },
  methods: {
    upDataInfo() {
      window.open(
          "https://homeimage.ksaxshop.com/%E5%B9%B3%E5%8F%B0%E5%95%86%E5%93%81%E5%AF%BC%E5%85%A5%281%29.xlsx"
      );
    },
    handlePicker(date) {
      if (date == null) {
        this.valueTime = []
        this.queryForm.StartTime = null
        this.queryForm.EndTime = null
      } else {
        this.queryForm.StartTime = date[0]
        this.queryForm.EndTime = date[1]
      }
    },
    selectType(val) {
      // console.log('sdsdsdsd', val);
      this.submitData.PlatformCodeType = val;
    },
    async getProductPlatformSyncRecordGetAll() {
      this.tableLoading = true;
      this.queryForm.SkipCount = (this.queryForm.PageIndex - 1) * this.queryForm.PageSize;
      this.queryForm.MaxResultCount = this.queryForm.PageSize;
      // console.log('this.queryForm', this.queryForm)
      // console.log('this.this.queryForm.PageIndex - 1', this.queryForm.PageIndex)
      let res = await ProductPlatformSyncRecordGetAll(this.queryForm)
      // console.log('result: 操作记录', res)
      if (res.data.success) {
        this.tableLoading = false
        this.userList = res.data.result.items || [];
        this.total = res.data.result.totalCount;
      } else {
        this.$message.error(res.data.error.message || ' 获取记录失败, 请重试')
      }
    },
    getJdTypeGetAll() {
      JdTypeGetAll({Type: 1}).then((res) => {
        // console.log('res', res);
        let JdType = res;
        JdType = res && res.data && res.data.result && res.data.result.items.map(item => {
          return {
            value: item.platformTypeId,
            label: item.typeName,
            id: item.id,
            parentId: item.parentId
          }
        })

        let jdTypeTree = this.getJdTypeTree(JdType)

        this.productNavTypeTreeList1 = jdTypeTree;
        // console.log('this.productNavTypeTreeList1+++++++++', this.productNavTypeTreeList1)
        // that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    getJdTypeTree(JdType) {
      // console.log('jdTypeTree-------', JdType)

      let data = [...JdType];
      // console.log('data', data);
      let map = {};
      data.forEach(item => {
        map[item.id] = item;
      });

      let val = [];

      data.forEach(item => {
        let parent = map[item.parentId];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          val.push(item)
        }
        //     console.log('data', parent)
        // console.log('parent', parent)
        // console.log('val', JSON.stringify(val, null, 2))
        // return;
      })
      return val
    },
    getJdBrandGetAll(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
        Type: 1
      };
      if (key) {
        obj.BrandName = key;
      }
      return new Promise((resolve, reject) => {
        JdBrandGetAll(obj).then((res) => {
          console.log('jd brand', res);
          if (res.data.success) {
            this.JdBrandList = res.data.result.items.map((item) => {
              return {
                value: item.brandName,
                id: item.jdId,
              };
            });
            resolve(this.JdBrandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },

    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({parentId: 0}).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    handleExpSubmit() {
      // console.log('this.fileLog',this.fileLog)
      if (!this.fileLog) {
        return this.$message.error('请选择上传的文件')
      }
      this.$confirm("确认上传吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.uploading = true;
        let formData = new window.FormData();
        formData.append("file", this.fileLog);
        ProductUploadJDCtp(formData).then((res) => {
          if (res.data.success) {
            this.$message.success('上传成功！');
            this.uploading = false;
            // this.logisticsVisible = false;
            // this.fileLog = null;
            this.$refs.upLoadFile.clearFiles();
            // this.getTableList();
            this.getProductPlatformSyncRecordGetAll();
            this.infoData = res.data.result || {};
            this.importDialog = true;
          } else {
            this.$message.error(res.data.error.message);
            this.uploading = false;
          }
        });
      }).catch(() => {
      });

    },
    updataLogistics(e) {
      let that = this;
      let index1 = e.raw.name.lastIndexOf(".") + 1;
      let index2 = e.raw.name.length;
      let type = e.raw.name.substring(index1, index2);
      if (type !== "xlsx")
        return that.$message.error("请上传文件格式为xlsx文件");
      that.fileLog = e.raw;
    },
    removeLogistics() {
      this.fileLog = null;
    },
    fetchBy(val) {
      // console.log('feetch',val , typeof val)
      if (val === 1) {
        this.submitData.PlatformSyncType = 1;
        this.directType = true;
        this.matchType = false;
      } else {
        this.directType = false;
        this.matchType = true;
        this.submitData.PlatformSyncType = 2
      }
    },
    submitBtn() {
    },
    handleSelect1(item) {
      // console.log('item', item)
      // this.BrandIds = item.id;
      // this.submitData.JdTypeId = item.id;
      this.submitData.JdTypeName = item.value;
      // console.log('data', this.submitData)
    },
    handleSelect(item) {
      // console.log('item', item)
      // this.BrandIds = item.id;
      this.submitData.brandId = item.id;
      this.submitData.brandName = item.value;
    },
    clearBtn(val) {
      // this.BrandIds =
      this.submitData.brandId = null;
      this.submitData.brandName = '';
    },
    clearBtn1(val) {
      this.submitData.JdTypeName = '';
    },
    async querySearchAsync1(queryString, cb) {
      if (queryString) {
        let res = await this.getJdBrandGetAll(queryString);
        cb(res);
      } else {
        let res = await this.getJdBrandGetAll();
        cb(res);
      }
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },

    handleSelJDType(val) {
      // console.log(val)
      this.formData.jdTypeId = val.pop()
    },

    handleJDBrandInput(e) {
      this.getJDBrandList(e);
    },
    handleJDBrandSelect(e) {
      this.formData.jdBrandId = e.id;
      this.formData.jdBrandName = e.value;
    },

    determineBtn() {
      // console.log('this.submitData', this.submitData)
      if (!this.submitData.brandName) {
        return this.$message.error('请选择平台数据品牌名称')
      }

      if (!this.submitData.brandId) {
        return this.$message.error('缺少平台数据品牌Id')
      }

      if (!this.submitData.CategoryId) {
        return this.$message.error('缺少平台数据分类Id')
      }

      if (!this.submitData.CategoryName) {
        return this.$message.error('请选择平台数据分类名称')
      }

      if (!this.submitData.Categorys) {
        return this.$message.error('缺少分类类型')
      }
      if (!this.submitData.JdTypeName) {
        return this.$message.error('缺少京东品牌名称')
      }
      if (!this.submitData.JdTypeId) {
        return this.$message.error('缺少京东分类信息Id')
      }
      let that = this;

      this.$confirm("确认拉取商品吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        if (this.submitData.PlatformCodeType == 1) {
          GetJDCtpProduct(this.submitData).then(res => {
            if (res.data.success) {
              that.infoDialog = true;
              this.$message.success('拉取成功')
              that.infoData = res.data.result;
            } else {
              that.$message.error(res.data.error.message || '获取失败,请重试')
            }
          })
        } else if (this.submitData.PlatformCodeType == 2) {
          JDPopProductQuery(this.submitData).then(res => {
            if (res.data.success) {
              that.infoDialog = true;
              this.$message.success('拉取成功')
              that.infoData = res.data.result;
            } else {
              that.$message.error(res.data.error.message || '获取失败,请重试')
            }
          })
        }
      }).catch(() => {
      });


    },

    handleSelType(val) {
      // console.log('val', val)
      console.log('categoryids', this.CategoryIds)
      // this.formData.typeId = val.pop()
      // let {path, pathLabels} = this.$refs['cascader1'].getCheckedNodes()[0];
      // console.log(path, pathLabels)
    },
    handleSelType1(val) {
      // console.log('val', val)
      this.submitData.JdTypeId = val;
      // console.log('categoryids', this.CategoryIds)
      // this.formData.typeId = val.pop()
      // let {path, pathLabels} = this.$refs['cascader1'].getCheckedNodes()[0];
      // console.log(path, pathLabels)
    },
    handleBrandInput(e) {
      this.getBrandList(e);
    },
    handleBrandSelect(e) {
      this.formData.brandId = e.id;
    },


    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 || columnIndex === 1) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    addProduct() {
      this.addProductDialog = true;
    },
    renderButton() {
      let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
      this.buttonList_table = this.$utils.sortDataArrayAsc(buttonList.filter((item) => {
        return item.buttonShow == 20 && item.isVisible;
      }), 'order');
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    getUserList() {
      this.tableLoading = true;
      let params = {
        Keyword: this.queryForm.Keyword,
        IsActive: this.queryForm.IsActive,
        SkipCount: (this.queryForm.pageIndex - 1) * 10,
        MaxResultCount: this.queryForm.pageSize
      }
      let that = this;
      GetAllUser(params).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        that.userList = res.data.result.items;
      });
    },
    handleSelectionChange(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      this.queryForm.PageIndex = val;
      this.getProductPlatformSyncRecordGetAll();
    },
    handleSizeChange(val) {
      this.queryForm.PageIndex = val;
      this.getProductPlatformSyncRecordGetAll();
    },
    search() {
      // console.log('sdadadaads', this.queryForm)
      this.queryForm.PageIndex = 1;
      this.queryForm.PageSize = 10;
      this.getProductPlatformSyncRecordGetAll();
    },
    empty() {
      // this.queryForm.Keyword = null;
      // this.queryForm.IsActive = null;
      this.queryForm.PageIndex = 1;
      this.queryForm.PageSize = 10;
      this.queryForm.TimeType = null;
      this.queryForm.creatorUser = '';
      this.queryForm.StartTime = null;
      this.queryForm.EndTime = null;
      this.valueTime = [];
      this.getProductPlatformSyncRecordGetAll();

    },
    addUser() {
      this.userFormVisible = true;
      this.isEdit = false;
      this.userForm = {
        userName: null,
        name: null,
        surname: null,
        password: null,
        emailAddress: null,
        isActive: true,
        roleNames: []
      }
    },
    editUser() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要编辑的一行数据！');
      }
      let params = {Id: row.id};
      let that = this;
      GetUserDetail(params).then((res) => {
        if (res.data.success) {
          that.userForm = res.data.result;
          that.isEdit = true;
          that.userFormVisible = true;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    delUser() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择要删除的一行数据！');
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableLoading = true;
        let params = {Id: row.id};
        let that = this;
        DeleteUser(params).then((res) => {
          that.tableLoading = false;
          if (res.data.success) {
            that.$message.success('删除成功');
            that.getUserList();
          } else {
            that.$message.error(res.data.msg);
          }
        });
      }).catch(() => {
      });
    },
    submitUser() {
      let that = this;
      that.$refs.userForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            if (!that.isEdit) {
              // surname必填且不能为空、不能为空字符串。。。
              that.userForm.surname = that.userForm.name;
              CreateUser(that.userForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('新增成功');
                  that.userFormVisible = false;
                  that.getUserList();
                } else {
                  that.$message.error(res.data.msg);
                }
              });
            } else {
              UpdateUser(that.userForm).then((res) => {
                that.submitLoading = false;
                if (res.data.success) {
                  that.$message.success('修改成功');
                  that.userFormVisible = false;
                  that.getUserList();
                } else {
                  that.$message.error(res.data.error.message)
                }
              });
            }
          }).catch(() => {
          });
        }
      });
    },
    getRolesList() {
      let that = this;
      GetRoles().then((res) => {
        that.roleList = res.data.result.items;
      });
    },
    setRoles() {
      let row = this.currentRow;
      if (!row) {
        return this.$message.error('请选择一行数据！');
      }
      let params = {Id: row.id};
      let that = this;
      GetUserDetail(params).then((res) => {
        if (res.data.success) {
          that.userForm = res.data.result;
          that.setPriceDialog = true;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    submitAddPro() {
      this.setPriceDialog = true;
      // this.$confirm("确认提交吗？", "提示", {
      //   closeOnClickModal: false,
      // }).then(() => {
      //   this.submitLoading = true;
      //   let that = this;
      //   UpdateUser(that.userForm).then((res) => {
      //     that.submitLoading = false;
      //     if (res.data.success) {
      //       that.$message.success('提交成功');
      //       that.setPriceDialog = false;
      //     } else {
      //       that.$message.error(res.data.error.message)
      //     }
      //   });
      // }).catch(() => {});
    },
    submitSetPrice() {
      let flag = true;
      try {
        this.setPriceList.forEach(x => {
          if (!x.supplyPrice && x.supplyPrice == '') {
            flag = false;
            this.$message.error('请输入供货价！');
            throw Error();
          }
          if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.supplyPrice)) {
            flag = false;
            this.$message.error('供货价必须为数字（可保留两位小数）');
            throw Error();
          }
          if (!x.status) {
            flag = false;
            this.$message.error('请选择上下架！');
            throw Error();
          }
        });
      } catch (e) {
      }
      if (flag) {
        this.$confirm("本次操作是否同步相应的分销商？", "提示", {
          closeOnClickModal: false,
        }).then(() => {
          // 调用接口，并同步
          this.setPriceDialog = false;
          this.addProductDialog = false;
        }).catch(() => {
          // 调用接口，不同步
          this.setPriceDialog = false;
          this.addProductDialog = false;
        });
      }
    },
    productSync() {
      this.proSyncDialog = true;
    },
    submitOneKeySync() {

    },
    batchSetPrice() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
      this.batchSetPriceDialog = true;
    },
    submitBatchSetPrice() {
      let flag = true;
      try {
        this.batchSetPriceList.forEach(x => {
          if (!x.supplyPrice && x.supplyPrice == '') {
            flag = false;
            this.$message.error('请输入供货价');
            throw Error();
          }
          if (!/^[0-9]+(.[0-9]{1,2})?$/.test(x.supplyPrice)) {
            flag = false;
            this.$message.error('供货价必须为数字（可保留两位小数）');
            throw Error();
          }
        });
      } catch (e) {
      }
      if (flag) {
        this.$confirm("本次操作是否同步相应的分销商？", "提示", {
          closeOnClickModal: false,
        }).then(() => {
          // 调用接口，并同步
          this.batchSetPriceDialog = false;
        }).catch(() => {
          // 调用接口，不同步
          this.batchSetPriceDialog = false;
        });
      }
    },
    batchOffShelf() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
    },
    batchShelves() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
    },
    batchImport() {
      if (this.currentRow.length == 0) {
        return this.$message.error('请选择一行数据！');
      }
    },
    offTheShelf(params) {
      let row = params.funcParams;
    },
    productSync_tab(params) {
      let row = params.funcParams;
      if (!row.supplyPrice || row.supplyPrice == '') {
        var elements = document.querySelectorAll('#user-table .el-table__body-wrapper')[0];
        let scrollWidth = elements.scrollWidth;
        elements.scrollLeft = scrollWidth;
        return this.$message.error('请输入供货价格！');
      }
    },
    detail(params) {
      let row = params.funcParams;
    }
  }
};
</script>
<style scoped>
#main-box {
  width: 100%;
  height: 100%;
}

#content-box {
  padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%;
}

#main-box /deep/ .el-pagination {
  padding: 10px 5px;
}


.tool_box {
  padding-top: 20px;
  overflow: hidden;
}

.flex {
  display: flex
}

.flex-center {
  align-items: center;
}

.data-detail-wrap {
  padding: 30px;
}

.data-detail-wrap .dataBox {
  margin-top: 40px;
}

.elSelect {
  width: 200px;
}

.el-dialog {
  padding-bottom: 0;
}

.img_box {
  width: 120px;
  height: 120px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  position: relative;
  margin-right: 10px;
  display: inline-block;
}

.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.del_box {
  position: absolute;
  top: -15px;
  right: -10px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.play_btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  z-index: 2;
}

.play_btn i {
  font-size: 25px;
  color: #666;
  border: 1px solid #666;
  border-radius: 50%;
  cursor: pointer;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.avatar-uploader {
  display: inline-block;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.video-uploader {
  display: inline-block;
}

.video-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.videoWrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, .6);
}

.videoWrapInner {
  background: white;
  width: 600px;
  height: 400px;
}

.picPreview {
  display: flex;
  margin-bottom: 15px;
}

.picPreview div {
  width: 120px;
  height: 120px;
  overflow: hidden;
  margin-right: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: relative;
}

.del {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.del img {
  height: 100%;
  width: 100%;
}


.contrast {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.left-box {
  border: 1px solid #dcdfe6;
  width: 400px;
  /* height: 300px; */
  padding: 20px;
}

.txt {
  font-weight: 700;
  color: #333;
}

.arrow {
  width: 100px;
  height: 50px;
  font-size: 70px;
  color: #606266;
  text-align: center;
}

.tab-box {
  margin-top: 20px;
}
</style>
